import dashboardLayout from "../layouts/MainDashboard/dashboard-layout";
import login from "../views/FrontPage/login-page";
import setupProfileLogo from "../views/FrontPage/company-logo-form";
import setupProfileDetails from "../views/FrontPage/company-details-form";
import successCurtain from "../views/FrontPage/success-curtain";
import errorPage from "../views/error-page";
import accessToken from "../helpers/accessToken";
import checkout from "../views/razorpay/checkout";
import paymentSuccess from "../views/razorpay/payment-success";
import paymentFailed from "../views/razorpay/payment-failed";
import paymentPending from '../views/razorpay/payment-pending'
import discovery from '../views/MainDashboard/DiscoverDashboard/discover'
import landingPage from '../views/LandingPage/landing-page'
// import setupProfileLogoMobile from '../views/SignupPageMobile/'
import accountCreated from '../views/AccountCreated/AccountCreated.vue'
function redirectionForLoginPage(to, from, next) {
  if (accessToken.getAccessToken()) next({ name: "createContent" });
  next();
}

const routes = [

  {
    path: "/home",
    name: "landingPage",
    component: ()=>import("../views/LandingPage/landing-page"),
    meta: {
      title: "Landing Page | Krishify Business",
      requiresAuth: false,
     
    },
  },

  {
    path: "/mobileLogin",
    name: "loginPageMobile",
    component: ()=>import("../views/LoginPageMobile/loginPage-mobile"),
    meta: {
      title: "Login Page Mobile | Krishify Business",
      requiresAuth: false,
     
    },
  },

  {
    path: "/login",
    name: "login",
    component: login,
    beforeEnter: redirectionForLoginPage,
    meta: {
      title: "Login | Krishify Business",
      requiresAuth: false,
    },
  },

  {
    path: "/login/setup-profile/details",
    name: "setupProfileDetails",
    component: setupProfileDetails,
    meta: {
      title: "Setup Profile | Krishify Business",
      requiresAuth: false,
      isOnboardPage: true,
    },
  },
  {
    path: "/login/setup-profile/logo",
    name: "setupProfileLogoMobile",
    component: ()=>import("../views/SignupPageMobile/upload-logo-cover.vue"),
    meta: {
      title: "Setup Profile Logo | Krishify Business",
      requiresAuth: false,
      isOnboardPage: true,
    },
  },
  {
    path: "/login/setup-profile/cover",
    name: "setupProfileCoverMobile",
    component: ()=>import("../views/SignupPageMobile/upload-logo-cover.vue"),
    meta: {
      title: "Setup Profile Cover | Krishify Business",
      requiresAuth: false,
      isOnboardPage: true,
    },
  },
  {
    path: "/login/setup-profile/logo:",
    name: "setupProfileLogo",
    component: setupProfileLogo,
    meta: {
      title: "Setup Profile Logo | Krishify Business",
      requiresAuth: false,
      isOnboardPage: true,
    },
  },
  {
    path: "/login/setup-profile/timeline-photo",
    name: "setupProfileTimeline",
    component: setupProfileLogo,
    meta: {
      title: "Setup Profile Timeline | Krishify Business",
      requiresAuth: false,
      isOnboardPage: true,
    },
  },
  {
    path: "/accountCreated",
    name: "accountCreated",
    component: accountCreated,
    meta: {
      title: "Account Created | Krishify Business",
      requiresAuth: false,
    },
  },

  //checkout
  {
    path: "/order/:order_id/checkout",
    name: "checkout",
    component: checkout,
    meta: {
      title: "Payments | Krishify Business",
      requiresAuth: false,
      isOnboardPage: false,
    },
  },
  {
    path: "/payment-success/:payId/:orderId/:sign",
    name: "paymentSuccess",
    component: paymentSuccess,
    meta: {
      title: "Payment Success| Krishify Business",
      requiresAuth: false,
      isOnboardPage: false,
    },
  },

  {
    path: "/payment-failed/:payId/:orderId/:reason",
    name: "paymentFailed",
    component: paymentFailed,
    meta: {
      title: "Payment Failed| Krishify Business",
      requiresAuth: false,
      isOnboardPage: false,
    },
  },
  {
    path:"/crm",
    name:'userlist',
    component: ()=>import("../views/Crm/UserList/index"),
    meta: {
      title: "User Page | Krishify Business",
      requiresAuth: true,
     
    },

  },
  {
    path: "/user",
    name: "user",
    component: () =>
      import("../views/Crm/UserDetails/index.vue"),
    meta: {
      title: "User Details",
      requiresAuth: true,
      
    },
  },

  {
    path: "/payment-pending/:payId/:orderId/:reason",
    name: "paymentPending",
    component: paymentPending,
    meta: {
      title: "Payment Pending| Krishify Business",
      requiresAuth: false,
      isOnboardPage: false,
    },
  },

 

  {
    path: "/login/verify",
    name: "verifyCurtain",
    component: successCurtain,
    meta: {
      title: "Verify | Krishify Business",
      requiresAuth: false,
      isOnboardPage: true,
    },
  },
  
  

  {
    path: "",
    name: "MainDashboard",
    component: dashboardLayout,
    redirect: (to) => {
      if (to.meta.requiresAuth) {
        if (accessToken.getAccessToken()) return "create-content";
      }
      return "home";
    },
    meta: {
      title: "Dashboard",
      requiresAuth: true,
    },
    children: [
      
      {
        path: "/dashboard",
        name: "dashboard",
        component: () =>
          import("../views/MainDashboard/AnalyticsDashboard/dashboard"),
        meta: {
          title: "Dashboard | Krishify Business",
          requiresAuth: true,
        },
      },
      {
        path: "/newdashboard",
        name: "newdashboard",
        component: () =>
          import("../views/MainDashboard/AnalyticsDashboard/dashboard"),
        meta: {
          title: "Dashboard | Krishify Business",
          requiresAuth: true,
        },
      },
      // {
      //   path: "/discovery",
      //   name: "discovery",
      //   component: discovery,
      //   meta: {
      //     title: "Verify | Krishify Business",
      //     requiresAuth: false,
      //     isOnboardPage: false,
      //   },
      // },
      {
        path: "/products",
        name: "products",
        component: () => import("../views/MainDashboard/Products/products"),
        meta: {
          title: "Products | Krishify Business",
          requiresAuth: true,
        },
      },
      {
        path: "/retailers",
        name: "retailers",
        component: () => import("../views/MainDashboard/Retailers/retailers"),
        meta: {
          title: "Retailers | Krishify Business",
          requiresAuth: true,
        },
      },
      {
        path: "/query",
        name: "query",
        component: () => import("../views/MainDashboard/Query/query"),
        meta: {
          title: "Query | Krishify Business",
          requiresAuth: true,
        },
      },
      {
        path: "/market-intelligence",
        name: "market-intelligence",
        component: () => import("../views/MainDashboard/DiscoverDashboard/discover"),
        meta: {
          title: "Discover | Krishify Business",
          requiresAuth: true,
        },
      },
      {
        path: "/review",
        name: "review",
        component: () => import("../views/MainDashboard/Review/review"),
        meta: {
          title: "Discover | Krishify Business",
          requiresAuth: true,
        },
      },
      {
        path: "/messages",
        name: "messages",
        component: () => import("../views/MainDashboard/Messages/messages"),
        meta: {
          title: "Messages | Krishify Business",
          requiresAuth: true,
        },
      },
      {
        path: "/my-farmers",
        name: "myFarmers",
        component: () => import("../views/MainDashboard/MyFarmers/my-farmers"),
        meta: {
          title: "My Farmers | Krishify Business",
          requiresAuth: true,
        },
      },
      {
        path: "/active-inquiries",
        name: "activeLeads",
        component: () =>
          import("../views/MainDashboard/ActiveLeads/active-leads"),
        meta: {
          title: "My Farmers | Krishify Business",
          requiresAuth: true,
        },
      },
      
      {
        path: "/create-content",
        name: "createContent",
        component: () =>
          import("../views/MainDashboard/CreateContent/create-content"),
        meta: {
          title: "Create Content | Krishify Business",
          requiresAuth: true,
        },
      },

     

      // super admin panel
      {
        path: "/admin/businesslist",
        name: "adminpanel",
        component: () => import("../views/SuperAdminDashboard/BusinessList/businesslist"),
        meta: {
          title: "Super admin panel | Business list",
          requiresAuth: true,
        },
      },
      {
        path: "/admin/home",
        name: "home",
        component: () => import("../views/SuperAdminDashboard/Homepage/homepage"),
        meta: {
          title: "Super admin panel | Home",
          requiresAuth: true,
        },
      },

      // end of super admin panel
      {
        path: "/profile-settings",
        name: "settings",
        component: () => import("../views/MainDashboard/Profile/my-profile"),
        children: [
          {
            path: "",
            name: "profileSettings",
            component: () =>
              import("../views/MainDashboard/Profile/profile-settings"),
            meta: {
              title: "Settings | Krishify Business",
              requiresAuth: true,
            },
          },

          {
            path: "change-password",
            name: "changePassword",
            component: () =>
              import(
                "../views/MainDashboard/Profile/change-or-create-password"
              ),
            meta: {
              title: "Settings | Krishify Business",
              requiresAuth: true,
            },
          },

          {
            path: "create-password",
            name: "createPassword",
            component: () =>
              import(
                "../views/MainDashboard/Profile/change-or-create-password"
              ),
            meta: {
              title: "Settings | Krishify Business",
              requiresAuth: true,
            },
          },
        ],
        meta: {
          title: "Settings | Krishify Business",
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: "*",
    name: "notFound",
    component: errorPage,
  },
  
];

export default routes;
